import React from "react";
import { Link } from "~/components/Link";
import { AuthUserEvents } from "~/modules/analytics/events/auth";
import { Routes } from "~/routes";

/**
 * AuthCard
 * A simple card component for auth pages (login, register, verify)
 */
export function AuthCard(props: { children: React.ReactNode }) {
    return (
        <div className="w-full max-w-[420px] rounded-md border bg-card px-5 py-6 sm:px-8 sm:py-10 shadow-brand-sm">
            {props.children}
        </div>
    );
}

/**
 * AuthCardHeader
 * A header component for auth cards (login, register, verify)
 */
export function AuthCardHeader(props: {
    title: React.ReactNode;
    description: React.ReactNode;
}) {
    const { title, description } = props;

    return (
        <>
            <h1 className="text-xl sm:text-[1.375rem] font-normal tracking-tight text-slate-800">
                {title}
            </h1>
            <p className="mt-1.5 sm:mt-2 text-xs sm:text-sm leading-relaxed text-secondary-foreground">
                {description}
            </p>
        </>
    );
}

// // // //

const variantToFooterCtaCopy: Record<"login" | "register", string> = {
    login: "New to RWA.xyz?",
    register: "Already have an account?",
};

const variantToFooterCtaLabel: Record<"login" | "register", string> = {
    login: "Create account",
    register: "Sign in",
};

const variantToFooterCtaHref: Record<"login" | "register", string> = {
    login: Routes.register,
    register: Routes.login,
};

const variantToFooterCtaAnalyticsLabel: Record<"login" | "register", string> = {
    login: AuthUserEvents.LoginPageRegisterLinkClick,
    register: AuthUserEvents.RegisterPageLoginLinkClick,
};

export function AuthCardFooter(props: { variant: "login" | "register" }) {
    const footerCtaCopy = variantToFooterCtaCopy[props.variant];
    const footerCtaLabel = variantToFooterCtaLabel[props.variant];
    const footerCtaHref = variantToFooterCtaHref[props.variant];
    const footerCtaAnalyticsLabel =
        variantToFooterCtaAnalyticsLabel[props.variant];

    return (
        <p className="text-center text-xs sm:text-sm text-secondary-foreground">
            {footerCtaCopy}{" "}
            <Link
                href={footerCtaHref}
                variant="unstyled"
                className="font-normal text-link hover:text-link-hover hover:underline"
                analyticsLabel={footerCtaAnalyticsLabel}
            >
                {footerCtaLabel}
            </Link>
        </p>
    );
}
